export const DEFAULT_CODEBOOK = 'Default codebook'

export const FORBIDDEN_CODEBOOK_SYMBOLS = '":;<>'
export const FORBIDDEN_TAG_SYMBOLS = '";<>'

export const DEFAULT_SELECTED_ACTION = 'skipper'
export const DEFAULT_SELECTED_CODEBOOK = '*'

export const STORAGE_KEY = `${window.surveyId}${window.userId || 0}-codebooks`
